import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import access from "@/locales/en/access.json";
import auth from "@/locales/en/auth.json";
import common from "@/locales/en/common.json";
import components from "@/locales/en/components.json";
import games from "@/locales/en/games.json";
import wsDebug from "@/locales/en/wsDebug.json";

i18n.use(initReactI18next).init({
  lng: "en",
  fallbackLng: "en",
  defaultNS: "common",
  resources: {
    en: { access, auth, common, components, games, wsDebug },
  },
  interpolation: {
    escapeValue: false,
  },
});
